module.exports = __webpack_public_path__ + "static/media/seguro_tecnico.0a3cec58.svg";